import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBranchApi, branchCUApi, branchDisableRestoreApi } from "../../../apiservice/setting";
import { postData } from "../../../apiservice/apis";

export const fetchBranchList = createAsyncThunk(
  "branch/fetchBranchList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getBranchApi({ "select-type": "active" });      
      return res?.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createOrUpdateBranch = createAsyncThunk(
  "branch/createOrUpdateBranch",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await postData("/settings/branch-cu", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const deleteOrRestoreBranch = createAsyncThunk(
  "branch/deleteOrRestoreBranch",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await branchDisableRestoreApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
